/**
 * Imported FIRST by main.tsx, and it imports only `lib/handoffCode.ts`, which
 * imports nothing: so this runs before any other module of the app, and
 * before the error reporter starts. The admin console's one-time code
  * (`#handoff=<code>`) leaves the address bar here and stays in memory only.
  * Nothing else belongs in this file.
 */
import { captureHandoffFragment } from "./lib/handoffCode";

captureHandoffFragment();
